import { getSystemDetails } from "./getSystemDetails";

// 1. Send OTP to mobile for login
export async function otpMobileSign(req) {
  const { ip, userAgent } = await getSystemDetails();
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Client-IP": ip,
      "X-Client-User-Agent": userAgent,
      device_type: localStorage.getItem("deviceType") || "",
      device_id: localStorage.getItem("deviceId") || "",
      client_data: localStorage.getItem("clientData") || "",
      ...(req.site_id ? { site_id: req.site_id } : {}),
    },
    body: JSON.stringify(req),
  };
  return fetch("/shared/api/otpmobilesign", requestOptions).then((response) => response.json());
}

// 2. Resend OTP for mobile login
export async function otpMobileResend(req) {
  const { ip, userAgent } = await getSystemDetails();
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Client-IP": ip,
      "X-Client-User-Agent": userAgent,
      device_type: localStorage.getItem("deviceType") || "",
      device_id: localStorage.getItem("deviceId") || "",
      client_data: localStorage.getItem("clientData") || "",
      ...(req.site_id ? { site_id: req.site_id } : {}),
    },
    body: JSON.stringify(req),
  };
  return fetch("/shared/api/otpmobileresend", requestOptions).then((response) => response.json());
}

// 3. Verify OTP for mobile login
export async function otpMobileVerify(req) {
  const { ip, userAgent } = await getSystemDetails();
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Client-IP": ip,
      "X-Client-User-Agent": userAgent,
      device_type: localStorage.getItem("deviceType") || "",
      device_id: localStorage.getItem("deviceId") || "",
      client_data: localStorage.getItem("clientData") || "",
      ...(req.site_id ? { site_id: req.site_id } : {}),
    },
    body: JSON.stringify(req),
  };
  return fetch("/shared/api/otpmobileverify", requestOptions).then((response) => response.json());
}
